module.exports = __webpack_public_path__ + "img/pla_JINGXI.e9a2172b.png";